import { render, staticRenderFns } from "./buttonIncluir.vue?vue&type=template&id=4c18e879"
import script from "./buttonIncluir.ts?vue&type=script&lang=js&external"
export * from "./buttonIncluir.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c18e879')) {
      api.createRecord('4c18e879', component.options)
    } else {
      api.reload('4c18e879', component.options)
    }
    module.hot.accept("./buttonIncluir.vue?vue&type=template&id=4c18e879", function () {
      api.rerender('4c18e879', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/child/form/button/buttonIncluir.vue"
export default component.exports